import { Box, IconButton } from '@mui/material'
import { ChevronLeft48Regular, ChevronRight48Regular } from '@/components/Icon'
import styles from '../AttachmentImageGallery.module.scss'
import { attachmentImageGalleryMainImageSx } from './attachmentImageGalleryStageSx.js'

export function AttachmentImageGalleryStage({ canPrev, canNext, goPrev, goNext, previewSrc, current, zoom }) {
  return (
    <Box className={styles.stage}>
      {canPrev ? (
        <IconButton type="button" className={`${styles.sideNav} ${styles.sideNavLeft}`} onClick={goPrev} aria-label="Previous image" size="large">
          <ChevronLeft48Regular className={styles.sideNavIcon} aria-hidden />
        </IconButton>
      ) : (
        <Box className={`${styles.sideNav} ${styles.sideNavLeft}`} aria-hidden />
      )}
      <Box className={styles.imageViewport}>
        {previewSrc ? (
          <Box
            component="img"
            src={previewSrc}
            alt={current?.file?.name ?? ''}
            className={styles.mainImage}
            sx={attachmentImageGalleryMainImageSx(zoom)}
          />
        ) : null}
      </Box>
      {canNext ? (
        <IconButton type="button" className={`${styles.sideNav} ${styles.sideNavRight}`} onClick={goNext} aria-label="Next image" size="large">
          <ChevronRight48Regular className={styles.sideNavIcon} aria-hidden />
        </IconButton>
      ) : (
        <Box className={`${styles.sideNav} ${styles.sideNavRight}`} aria-hidden />
      )}
    </Box>
  )
}
